import { buildEndPoint } from '@mairistem/tools';

import baseUrl from './base';

export const getDocuments = (categorie, { page, perPage } = { page: 1, perPage: 50 }) =>
  `${baseUrl}/documents?categorie=${categorie}&page=${page}&perPage=${perPage}`;

export const deleteDocument = (id) => `${baseUrl}/documents/${id}`;

export const downloadDocument = (id) => `${baseUrl}/documents/${id}/download`;
export const getDocumentTemporaryUrl = (id) =>
  `${baseUrl}/documents/${id}/download?temporaryUrl=true`;
export const uploadDocument = (params) => buildEndPoint(`${baseUrl}/documents`, params);
